import { io } from "socket.io-client";


const socket = io(process.env.REACT_APP_BACKEND_URL, {
  auth: {
    userId: localStorage.getItem('userId') || crypto.randomUUID(),
  },
});

localStorage.setItem('userId', socket.auth.userId);




export default socket